import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { QuickSightDashboardsPage } from "src/components/views/erp/bi/QuickSightDashboardsPage.tsx";

export const Route = createFileRoute("/_authenticated/_shell/bi")({
	staticData: { title: i18n.t("bi_reporting"), legacyViewKey: "quickSightDashboardsPage" },
	component: RouteComponent,
});

function RouteComponent() {
	return <QuickSightDashboardsPage />;
}
